<template>
  <div>
    <el-table :data="feedingData" style="width: 100%">
      <el-table-column label="上料系统">
        <el-table-column prop="filedName" label="设备信息名称" width="120">
        </el-table-column>
        <el-table-column prop="filedUnit" label="信息单位" width="120">
        </el-table-column>
        <el-table-column prop="maxValue" label="最大值" width="120">
        </el-table-column>
        <el-table-column prop="minValue" label="最小值" width="120">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="primary" plain
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <!-- 点击编辑弹窗 -->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-form :model="feedingForm">
        <el-form-item label="设备信息名称" :label-width="formLabelWidth">
          <el-input
            v-model="feedingForm.filedName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="信息单位" :label-width="formLabelWidth">
          <el-input
            v-model="feedingForm.filedUnit"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="最大值" :label-width="formLabelWidth">
          <el-input
            v-model="feedingForm.maxValue"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="最小值" :label-width="formLabelWidth">
          <el-input
            v-model="feedingForm.minValue"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="feedingUpdates">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { feedingList, feedingUpdate } from "@/assets/api/feedingStyle";
export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible: false,
      feedingForm: {
        machineId: "MC001", //编辑页面的数据对象
        machineName: "",
        filedKey: "",
        filedName: "", //粉体总重量
        filedUnit: "", //KG
        isChoose: 0,
        maxValue: null,
        minValue: null,
      },
      formLabelWidth: "120px",
      //上料机数据
      feedingData: [],
    };
  },
  created() {
    this.feedingQuery();
  },
  methods: {
    //查询上料系统的数据
    feedingQuery() {
      feedingList(this.feedingForm).then((res) => {
        this.feedingData = res.data;
      });
    },
    //修改上料系统的数据
    feedingUpdates() {
      this.dialogFormVisible = false;
      feedingUpdate(this.feedingForm).then(res=>{
         this.feedingQuery();
        console.log(res);
      });
    },
    //点击编辑按钮赋值给编辑页面框
    handleClick(row) {
      this.dialogFormVisible = true;
      this.feedingForm.machineId=row.machineId; //编辑页面的数据对象
      this.feedingForm.machineName= row.machineName;
      this.feedingForm.filedKey=row.filedKey;
      this.feedingForm.filedName=row.filedName; //粉体总重量
      this.feedingForm.filedUnit=row.filedUnit; //KG
      this.feedingForm.isChoose=row.isChoose;
      this.feedingForm.maxValue=row.maxValue;
      this.feedingForm.minValue=row.minValue;
    }
  },
};
</script>
<style lang="less">
.el-table .cell {
  color: #000;
  text-align: center;
  font-size: 17px;
}
</style>